export const pie = {
    outerRadius: .6,
    pie: {
        style: {
            fillOpacity: 1
        }
    },
    label: {
        visible: !1,
        interactive: !0,
        position: "outside",
        style: {
            fontWeight: "normal",
            stroke: {
                type: "palette",
                key: "backgroundColor"
            },
            fillOpacity: 1
        }
    },
    innerLabel: {
        style: {
            lineWidth: 2
        }
    },
    emptyCircle: {
        style: {
            fill: {
                type: "palette",
                key: "emptyCircleColor"
            },
            fillOpacity: 1
        }
    }
};
//# sourceMappingURL=pie.js.map
